<app-customer-review-layout
  [headerCtaLabel]="'LOGIN.DONT_HAVE_ACCOUNT' | translate"
  [headerCtaRoute]="registerRoute"
  [title]="'ACTION.LOG_IN' | translate"
  [errorMessage]="error$ | async"
  [trackingObject]="trackingObject$ | async"
  [trackingScreenName]="trackingScreenName"
  (facebookLoginSuccess)="loginAccountByFacebook($event.email, $event.idToken)"
  (facebookLoginError)="setErrorMessage($event.message)"
  (appleLoginSuccess)="loginAccountByApple($event.email, $event.idToken)"
  (appleLoginError)="setErrorMessage($event.message)"
  (googleLoginSuccess)="loginAccountByGoogle($event.email, $event.idToken)"
  (googleLoginError)="setErrorMessage($event.message)"
>
  <app-email-login
    class="email-login"
    [processing]="processing$ | async"
    [trackingObject]="trackingObject$ | async"
    [trackingAction]="emailLoginTrackingAction"
    (buttonSubmit)="loginByEmailAndPassword($event.email, $event.password)"
  >
  </app-email-login>
</app-customer-review-layout>
